import { forwardRef, createElement } from 'react';

function IconEntryTypeSupplierInvoice(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M19.5 8l3 3v8.25A1.75 1.75 0 0120.75 21h-7.5a1.75 1.75 0 01-1.75-1.75v-9.5c0-.966.784-1.75 1.75-1.75h6.25zm-1 1.5h-5.25a.25.25 0 00-.243.193L13 9.75v9.5a.25.25 0 00.193.243l.057.007h7.5a.25.25 0 00.243-.193L21 19.25V12h-2.5V9.5zm.25 7a.75.75 0 110 1.5h-3.5a.75.75 0 110-1.5h3.5zM6.25 14a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM18 3a1.75 1.75 0 011.744 1.606l.006.144V7h-6.27a3.11 3.11 0 00-1.955.675l-.152.13a2.654 2.654 0 00-.866 1.757l-.007.188v5.5H8.738a2.5 2.5 0 00-2.324-2.245L6.25 13a2.5 2.5 0 00-2.488 2.25H2.25l-.102-.007a.75.75 0 01-.641-.641L1.5 14.5V9.929l.008-.108a.75.75 0 01.112-.3l.066-.086 3-3.429.076-.075a.75.75 0 01.381-.173l.107-.008h2.5v-1a1.75 1.75 0 011.606-1.744L9.5 3H18zm.75 10.5a.75.75 0 110 1.5h-3.5a.75.75 0 110-1.5h3.5zM7 7.25H5.59L4 9.068V10h3V7.25z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var EntryTypeSupplierInvoice = /*#__PURE__*/forwardRef(IconEntryTypeSupplierInvoice);

export default EntryTypeSupplierInvoice;
//# sourceMappingURL=EntryTypeSupplierInvoice.js.map
